import { useSiteSettings } from './useSiteSettings';
import { Content as ContentMetaDataTag } from 'src/.generated/Content/MetaDataTag.model';

type MetaDataTagFieldValue =
  | string
  | { value?: string; name?: string; displayName?: string }
  | Array<{ name?: string; displayName?: string }>;

function getMetaDataTagOptionValue(fieldValue: MetaDataTagFieldValue | undefined): string {
  if (!fieldValue) {
    return '';
  }
  if (typeof fieldValue === 'string') {
    return fieldValue;
  }
  if (Array.isArray(fieldValue)) {
    const firstItem = fieldValue[0];
    return firstItem?.name ?? firstItem?.displayName ?? '';
  }
  return fieldValue.name ?? fieldValue.displayName ?? fieldValue.value ?? '';
}

export interface MetaDataTagResult {
  labelName: string | undefined;
  metaDataTagAppearance: string;
  metaDataTagColor: string;
  defaultMetaDataTagAppearance: string;
  defaultMetaDataTagColor: string;
}

export function useMetaDataTag(metadataIds?: string[]): MetaDataTagResult {
  const siteSettings = useSiteSettings();
  const metaDataTagSettings = siteSettings?.metaDataTagSettings as
    | ContentMetaDataTag.MetaDataTag.MetaDataTag_Item
    | undefined;

  const defaultMetaDataTagAppearance =
    metaDataTagSettings?.fields?.DefaultLabelAppearance?.value || 'Fill';
  const defaultMetaDataTagColor =
    metaDataTagSettings?.fields?.DefaultLabelColour?.value || 'Type A';

  const tags = (metaDataTagSettings?.fields?.Tags ??
    []) as ContentMetaDataTag.MetaDataTag.MetaDataTagItem_Item[];

  const matchedTag = tags.find((tag) =>
    metadataIds?.includes(tag.fields?.MetadataServiceTags?.value ?? '')
  );

  const metaDataTagAppearance =
    getMetaDataTagOptionValue(matchedTag?.fields?.MetaDataTagAppearance?.value) ||
    defaultMetaDataTagAppearance;

  const metaDataTagColor =
    getMetaDataTagOptionValue(matchedTag?.fields?.MetaDataTagColor?.value) ||
    defaultMetaDataTagColor;

  return {
    labelName: matchedTag?.fields?.LabelName?.value,
    metaDataTagAppearance,
    metaDataTagColor,
    defaultMetaDataTagAppearance,
    defaultMetaDataTagColor,
  };
}
